import { Plan } from '@/types/plan';

import { apiClient } from '..';
import { toastError } from '@/services/toast';
import usePlansStore from '@/store/plansStore';
import { getGurupassClient } from '@/services/gurupass-api-client';

const plansStore = usePlansStore.getState();

type CreatePlanProps = {
	name: string;
	slug: string;
	description?: string;
	credits: number;
	price: number;
};

type UpdatePlanProps = {
	name?: string;
	description?: string;
	credits?: number;
	price?: number;
};

export async function createPlan(
	plan: CreatePlanProps
): Promise<Plan | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.plans().create(plan).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getPlans(forceRequest = false): Promise<Plan[]> {
	if (!forceRequest && plansStore.plans.length > 0) {
		return plansStore.plans;
	}

	return new Promise((resolve, reject) => {
		apiClient()
			.get('/api/admins/plans')
			.then(response => {
				plansStore.updatePlans(response.data);
				resolve(response.data);
			})
			.catch(error => {
				const message = error?.response?.data?.message || 'Erro ao carregar planos';
				toastError(message);
				reject(message);
			});
	});
}

export async function getFilteredPlans(params: any): Promise<Plan[]> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.plans().filter(params.params).run();
		return response?.data ?? [];
	} catch (error: any) {
		toastError(error?.data?.message);
		return [];
	}
}

export async function updatePlan(
	id: string,
	plan: UpdatePlanProps
): Promise<Plan[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.plans().update(id, plan).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function removePlan(id: string): Promise<Plan[] | undefined> {
	const client = getGurupassClient();
	try {
		const response: any = await client?.admin.plans().remove(id).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function createUnlimitedPlan(plan: {
	name: string;
	description?: string;
	maxCredits: number;
	price: number;
}) {
	const client = getGurupassClient();
	try {
		const response: any = await client?.admin
			.plans()
			.createUnlimited(plan)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}
